import api from './axios';

export const getAuditoria = (params = {}) =>
  api.get('/auditoria', { params }).then((r) => r.data);

export const getAuditoriaMeta = () =>
  api.get('/auditoria/meta').then((r) => r.data);
